/* Auto Generated */

export enum TrainingMethod {
	training = 0,
	inCompany = 1,
	elearning = 2,
	inCompanyModular = 3,
}
